import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import Layer5 from "../../../../src/collections/blog/2023/Load-Generation-Load-Balancing/Layer5.svg";
import * as React from 'react';
export default {
  BlogWrapper,
  Layer5,
  React
};